var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1024.001 1024.003",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M988.852 175.22c-22.664-22.656-52.79-35.14-84.828-35.14H904l-387.405-.01c-10.875.11-20.813-5.187-26.656-13.944L428.516 34H120C53.83 34 0 87.83 0 154v644.15c0 66.163 53.83 120 120 120h408v-80H120c-22.054 0-40-17.946-40-40V366.085c0-10.688 4.165-20.727 11.72-28.29 7.555-7.546 17.594-11.71 28.29-11.71l307.038-.016 62.883-91.5c5.69-8.54 16.415-14.5 26.07-14.5v-.008c.134 0 .274.008.415.008l387.594.008c10.68 0 20.718 4.156 28.272 11.71s11.72 17.603 11.72 28.282v400h80v-400c0-32.055-12.485-62.188-35.15-84.852zM423.54 189.93l-38.587 56.142-264.93.016H120c-13.844 0-27.32 2.336-40 6.813v-98.897c0-22.055 17.945-40 40-40h265.703l37.672 56.508c2.297 3.446 4.797 6.712 7.43 9.845-2.57 3.055-5.023 6.234-7.266 9.578zM856 740.07h168v80H856v168h-80v-168H608v-80h168v-168h80z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddFolder);
export default __webpack_public_path__ + "static/media/addFolder.bcd6b326a254d4365f021b58566bc3e6.svg";
export { ForwardRef as ReactComponent };